const STORAGE_KEYS = {
  token: "authToken",
  username: "username",
  isEmailVerified: "isEmailVerified",
  hasAllegroConnected: "hasAllegroConnected",
};

const getStorage = () => {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export const readAuthSnapshot = () => {
  const storage = getStorage();
  if (!storage) {
    return {
      token: null,
      username: null,
      isEmailVerified: false,
      hasAllegroConnected: false,
    };
  }

  return {
    token: storage.getItem(STORAGE_KEYS.token),
    username: storage.getItem(STORAGE_KEYS.username),
    isEmailVerified: storage.getItem(STORAGE_KEYS.isEmailVerified) === "true",
    hasAllegroConnected: storage.getItem(STORAGE_KEYS.hasAllegroConnected) === "true",
  };
};

export const persistAuthSnapshot = (snapshot) => {
  const storage = getStorage();
  if (!storage) return;

  if (typeof snapshot.token !== "undefined") {
    if (snapshot.token === null) storage.removeItem(STORAGE_KEYS.token);
    else storage.setItem(STORAGE_KEYS.token, snapshot.token);
  }

  if (typeof snapshot.username !== "undefined") {
    if (snapshot.username === null) storage.removeItem(STORAGE_KEYS.username);
    else storage.setItem(STORAGE_KEYS.username, snapshot.username);
  }

  if (typeof snapshot.isEmailVerified !== "undefined") {
    storage.setItem(
      STORAGE_KEYS.isEmailVerified,
      snapshot.isEmailVerified ? "true" : "false"
    );
  }

  if (typeof snapshot.hasAllegroConnected !== "undefined") {
    storage.setItem(
      STORAGE_KEYS.hasAllegroConnected,
      snapshot.hasAllegroConnected ? "true" : "false"
    );
  }
};

export const clearAuthSnapshot = () => {
  const storage = getStorage();
  if (!storage) return;
  Object.values(STORAGE_KEYS).forEach((key) => storage.removeItem(key));
};
